module.exports = __webpack_public_path__ + "img/LI.e23bc6ef.svg";